import { FETCH_SPLASH_RAND, FETCH_AVATAR_RAND } from './types';

export default {
    [FETCH_SPLASH_RAND](state, payload) {
        state.splash = payload.url;
    },
    [FETCH_AVATAR_RAND](state, payload) {
        state.avatar = payload.url;
    },
};



// WEBPACK FOOTER //
// ./src/store/asset/mutations.js